var map = {
	"./EtiquetadosDiapositiva.jsx": 6658,
	"./Hello.jsx": 2106,
	"./Index.jsx": 6994,
	"./Livescoring.jsx": 8566,
	"./OnTheTee.jsx": 8116,
	"./Plazas.jsx": 3140,
	"./SearchPanel.jsx": 6269,
	"./TournamentScoreboard.jsx": 6241,
	"./Weather.jsx": 6399,
	"./rydercup/components/Holes.jsx": 8085,
	"./rydercup/components/MatchCard.jsx": 5344,
	"./rydercup/components/SessionView.jsx": 2593,
	"./rydercup/components/Team.jsx": 1016,
	"./rydercup/components/TournamentHeader.jsx": 9305,
	"./rydercup/components/TournamentLegend.jsx": 1486,
	"./rydercup/components/ui/Tabs.jsx": 7205,
	"./rydercup/lib/Utils.js": 670,
	"./rydercup/types/Types.js": 3340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4532;